var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlikeButtonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4868_1156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.59375,
    width: 50,
    height: 52.2222,
    rx: 11.1111,
    fill: "#FC7700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.09375,
    width: 49,
    height: 51.2222,
    rx: 10.6111,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2523 15.1953V28.9453M40.5023 24.9453V19.1953C40.5023 17.7952 40.5023 17.0951 40.2298 16.5603C39.9901 16.0899 39.6076 15.7075 39.1372 15.4678C38.6025 15.1953 37.9024 15.1953 36.5023 15.1953H23.1498C21.3229 15.1953 20.4095 15.1953 19.6717 15.5296C19.0215 15.8242 18.4689 16.2983 18.0788 16.8962C17.6362 17.5746 17.4973 18.4774 17.2195 20.283L16.5657 24.533C16.1993 26.9145 16.0161 28.1052 16.3695 29.0317C16.6797 29.8449 17.2631 30.5249 18.0197 30.9551C18.8817 31.4453 20.0864 31.4453 22.4959 31.4453H23.5023C24.2023 31.4453 24.5524 31.4453 24.8198 31.5816C25.055 31.7014 25.2462 31.8926 25.366 32.1278C25.5023 32.3952 25.5023 32.7452 25.5023 33.4453V37.113C25.5023 38.8153 26.8823 40.1953 28.5846 40.1953C28.9906 40.1953 29.3585 39.9562 29.5234 39.5852L33.7244 30.133C33.9155 29.7031 34.011 29.4882 34.162 29.3305C34.2955 29.1912 34.4594 29.0847 34.641 29.0193C34.8463 28.9453 35.0815 28.9453 35.552 28.9453H36.5023C37.9024 28.9453 38.6025 28.9453 39.1372 28.6728C39.6076 28.4331 39.9901 28.0507 40.2298 27.5803C40.5023 27.0455 40.5023 26.3454 40.5023 24.9453Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4868_1156",
    x: 0.222222,
    y: 0.204861,
    width: 55.5556,
    height: 57.7743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38889
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4868_1156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4868_1156",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikeButtonActive);
export default __webpack_public_path__ + "static/media/Unlike Button - active.6db21507d0ed746835f7b6be83e37941.svg";
export { ForwardRef as ReactComponent };